export default __webpack_public_path__ + "static/media/look-up-button-01.f1e80ca4.svg";